import React, { SVGProps } from 'react';
import * as Icons from '../../index';
import { type NiaraIconNameType } from '../../index';
type IconProps = SVGProps<SVGElement> & {
  icon: NiaraIconNameType;
  size?: number;
  color?: string;
  backgroundColor?: string;
};
const Icon = (props: IconProps): JSX.Element => {
  const {
    size = 16,
    icon,
    color,
    backgroundColor,
    ...rest
  } = props;
  const Icon = Icons[icon];
  return Icon && <Icon height={size} width={size} style={{
    color,
    backgroundColor
  }} {...rest} />;
};
export default Icon;